import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'

import {
  enableIosContextMenu,
  disableIosContextMenu,
} from '@/services/capacitor.contextMenuPlugin'


export default /*@__PURE__*/_defineComponent({
  __name: 'InputWithContextMenu',
  props: {
    elementType: { default: 'input' },
    modelValue: { default: '' },
    autoResize: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const inputElement = ref<HTMLInputElement | null>(null)

/**
 * If the component has `autoResize`, resize it on load
 * to make sure it renders at the correct height.
 */
onMounted(() => {
  if (!inputElement.value) {
    return
  }

  if (props.autoResize && props.elementType === 'textarea') {
    resizeTextArea(inputElement.value)
  }
})

/**
 * Emit the input value. If the component has `autoResize`,
 * update its height.
 */
function handleInput(event: InputEvent): void {
  const target = event.target as HTMLInputElement

  emit('update:modelValue', target.value)

  if (props.autoResize && props.elementType === 'textarea') {
    resizeTextArea(target)
  }
}

/**
 * Update the text area's element's height based on its contents.
 */
function resizeTextArea(element: HTMLInputElement): void {
  // Reset height to 'auto' to ensure the `scrollHeight` is accurate before resizing.
  element.style.height = 'auto'
  element.style.height = `${element.scrollHeight}px`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.elementType), {
    ref_key: "inputElement",
    ref: inputElement,
    value: __props.modelValue,
    class: _normalizeClass({ 'auto-resize-input': __props.autoResize }),
    onInput: _cache[0] || (_cache[0] = (event) => handleInput(event)),
    onFocusin: _unref(enableIosContextMenu),
    onFocusout: _unref(disableIosContextMenu)
  }, null, 40, ["value", "class", "onFocusin", "onFocusout"]))
}
}

})